<template>
    <div class="index">
        <router-view v-wechat-title="$route.meta.title"></router-view>
        <div>目录</div>
        <ul class="menu">
            <li class="head">
                <router-link to="/">逛.河博</router-link>
            </li>
            <li>
                <router-link to="/synopsis/visit_service">----了解河博</router-link>
            </li>
            <li>
                <router-link to="/synopsis/clzl">----陈列展览</router-link>
            </li>
            <li>
                <router-link to="/tour/hbjz">----河博集珍</router-link>
            </li>
            <li>
                <router-link to="/service/yaoyiyao">----摇一摇</router-link>
            </li>
        </ul>

        <ul class="menu">
            <li class="head">
                <router-link to="/">用.导览</router-link>
            </li>
            <li>
                <router-link to="/tour/online">----语音导览</router-link>
            </li>
            <li>
                <a href="http://www.hebeimuseum.org/contents/154/2154.html">----数字展厅</a>
            </li>
            <!--<li>
                <a href="https://hbbwy.museum-edu.cn/api/question/quesinfo?p=w&language=1&id=1">&#45;&#45;&#45;&#45;问卷调查</a>
            </li>-->
        </ul>

        <ul class="menu">
            <li class="head">
                <router-link to="/">享.服务</router-link>
            </li>
            <li>
                <router-link to="/service/interaction">----互动</router-link>
            </li>
            <li>
                <router-link to="/service/activity_yy/list">----预约</router-link>
            </li>
            <li>
                <router-link to="/synopsis/exhibition_zl">----讲坛</router-link>
            </li>
            <li>
                <router-link to="/tour/commodity">----文创</router-link>
            </li>
            <li>
                <a href="http://www.hebeimuseum.org/contents/35/1584.html">----志愿者</a>
            </li>

        </ul>
    </div>
</template>
<script>
  export default {
    name: 'index',
    data: function () {
      return {

      }
    },
    created: function () {

    },
    methods: {

    }
  }
</script>

<style scoped>

    .menu {
        padding: 0.5rem 1rem;
    }

    .menu li {
        font-size: 1rem;
        line-height: 200%;
    }

    .menu li.head {
        font-size: 1.2rem;
        font-weight: bold;
    }

    .token {
        padding: 2rem;
    }

    .token input {
        display: block;
        width: 100%;
        margin-bottom: 1rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/index.vue